
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import FreeAccessNavButton from "./FreeAccessNavButton";

const UserAuthButtons = () => {
  return (
    <div className="flex items-center gap-2">
      <FreeAccessNavButton />
      <Link to="/login">
        <Button variant="outline" size="sm">
          Log In
        </Button>
      </Link>
      <Link to="/login?tab=signup">
        <Button variant="default" size="sm">
          Sign Up
        </Button>
      </Link>
    </div>
  );
};

export default UserAuthButtons;
